<template>
    <div class="bg-a-brown-502314 text-a-egg-f5ebdc">
        <!--//? Mobile footer -->
        <div class="block lg:hidden p-4" v-show="!hideMobile">
            <div class="text-center text-24 font-bold">BURGER KING</div>
            <div class="flex justify-center text-12 mt-4">
                <router-link to="/privacy">Privacy Policy</router-link>
                <div class="px-2">|</div>
                <router-link to="/terms">Tearms & Conditions</router-link>
                <div class="px-2">|</div>
                <router-link to="/contact">Contact us</router-link>
            </div>
            <div class="flex justify-center mt-4">
                <a href="https://instagram.com/burgerkingthailand?igshid=YmMyMTA2M2Y=" class="block mr-4" target="_blank">
                    <img class="w-5" src="../../../assets/social/ig-icon.svg">
                </a>
                <a href="https://www.facebook.com/BurgerKingThailand" class="block ml-4" target="_blank">
                    <img class="w-5" src="../../../assets/social/fb-icon.svg">
                </a>
            </div>
            <div class="text-10 text-a-brown-bba596 text-center mt-4">
                TM & Copyright 2022 MINOR INTERNATIONAL PCL. All rights reserved.
            </div>
        </div>

        <!--//? Desktop footer -->
        <div class="hidden lg:block p-4">
            <div class="max-w-1140px m-auto">
                <div class="grid grid-cols-7">
                    <div class="col-span-4">
                        <div class="flex justify-between pr-16">
                            <div class="">
                                <div class="text-20 font-bold">BK INFO</div>
                                <router-link to="#" class="block text-14 mt-3">About Burger King</router-link>
                                <router-link to="/info/freshtaste" class="block text-14 mt-3">Fresh Taste</router-link>
                                <router-link to="/info/madetoorder" class="block text-14 mt-3">Made to Order</router-link>
                                <router-link to="#" class="block text-14 mt-3">Careers</router-link>
                            </div>
                            <div>
                                <router-link to="/store" class="block text-14 mt-9">Locations</router-link>
                                <router-link to="/info/promotions" class="block text-14 mt-3">Promotions</router-link>
                            </div>
                            <div>
                                <div class="text-20 font-bold">Members</div>
                                <router-link to="/login" v-show="isLoginGuest" class="block text-14 mt-3">Member Registration</router-link>
                                <router-link to="/point" class="block text-14 mt-3">Crown Points</router-link>
                                <router-link to="/reward" class="block text-14 mt-3">Rewards</router-link>
                            </div>
                        </div>
                    </div>
                    <div class="col-span-3 pl-16">
                        <div class="text-20 font-bold">BURGER KING</div>
                        <div class="flex text-14 mt-4">
                            <router-link to="/privacy">Privacy Policy</router-link>
                            <div class="px-2">|</div>
                            <router-link to="/terms">Terms & Conditions</router-link>
                            <div class="px-2">|</div>
                            <router-link to="/contact">Contact us</router-link>
                        </div>
                        <div class="flex mt-4">
                            <a href="https://instagram.com/burgerkingthailand?igshid=YmMyMTA2M2Y=" class="block mr-4" target="_blank">
                                <img class="w-5" src="../../../assets/social/ig-icon.svg">
                            </a>
                            <a href="https://www.facebook.com/BurgerKingThailand" class="block ml-4" target="_blank">
                                <img class="w-5" src="../../../assets/social/fb-icon.svg">
                            </a>
                        </div>
                        <div class="text-10 text-a-brown-bba596 mt-4">
                            TM & Copyright 2022 MINOR INTERNATIONAL PCL. All rights reserved.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import AuthStatusMixin from '@/mixin/AuthStatusMixin'

export default {
    mixins: [AuthStatusMixin],
    props: {
        hideMobile: { type: Boolean, default: false },
    },
}
</script>
<style lang="scss" scoped>
    .desktop-content {
        max-width: 1200px;
    }
</style>
